module.exports = __webpack_public_path__ + "images/128_4096.jpg";